<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">

  <div class="modal-header">
    <h4 class="modal-title">Add Participant</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">

    <div class="text-center" *ngIf="loading">
      Loading...
    </div>

    <ng-container *ngIf="!loading">

      <div class="alert alert-danger text-center mb-3" role="alert"
           *ngIf="errorMessage">
        {{ errorMessage }}
      </div>

      <p *ngIf="privateEvent">
        <b>{{ privateEvent.event_type_name }}</b>
      </p>

      <hr>

      <div class="form-group">
        <label>Participant</label>
        <p class="mb-1">
          <ng-container *ngIf="reservation.customer_id">
            {{ reservation.first_name }} {{ reservation.last_name }}
            (<span class="text-danger cursor-pointer underline-on-hover"
                   (click)="clearReservationCustomer()">Remove</span>)
          </ng-container>
          <span *ngIf="!reservation.customer_id" class="text-muted">
            None Selected
          </span>
        </p>

        <div class="d-block clearfix" *ngIf="!reservation.customer_id">
          <button class="btn btn-primary btn-sm" type="button"
                  (click)="openSelectCustomer()">
            Select Customer
          </button>
          <button class="btn btn-primary btn-sm ml-2" type="button"
                  (click)="openCreateNewCustomer()">
            Create New Customer
          </button>
        </div>
      </div>

      <div class="row" *ngFor="let question of participantQuestions">
        <div class="col-12">

          <div class="mt-2" *ngIf="question.question_type === EventQuestionType.singleLineText">
            <label [for]="'question-' + question.id.toString()">
              <span [innerHTML]="getRenderedInlineMarkdown(question.name)"></span>
              <span *ngIf="question.is_required">&nbsp;*</span>
            </label>
            <input type="text" class="form-control"
                   [id]="'question-' + question.id.toString()"
                   [name]="'question-' + question.id.toString()"
                   [(ngModel)]="reservation.question_responses[question.name]">
            <small class="form-text text-muted"
                   *ngIf="question.description"
                   [innerHTML]="getRenderedInlineMarkdown(question.description)"></small>
          </div>

          <div class="mt-2" *ngIf="question.question_type === EventQuestionType.multipleLineText">
            <label [for]="'question-' + question.id.toString()">
              <span [innerHTML]="getRenderedInlineMarkdown(question.name)"></span>
              <span *ngIf="question.is_required">&nbsp;*</span>
            </label>
            <textarea class="form-control"
                      [id]="'question-' + question.id.toString()"
                      [name]="'question-' + question.id.toString()"
                      [(ngModel)]="reservation.question_responses[question.name]"></textarea>
            <small class="form-text text-muted"
                   *ngIf="question.description"
                   [innerHTML]="getRenderedInlineMarkdown(question.description)"></small>
          </div>

          <div class="mt-2" *ngIf="question.question_type === EventQuestionType.multipleChoice">
            <label class="mb-1">
              <span [innerHTML]="getRenderedInlineMarkdown(question.name)"></span>
              <span *ngIf="question.is_required">&nbsp;*</span>
            </label>
            <div class="form-check" *ngFor="let option of question.options.split(','); let optionIdx = index;">
              <input class="form-check-input" type="radio"
                     [id]="'question-' + question.id.toString() + '-' + optionIdx.toString()"
                     [name]="'question-' + question.id.toString() + '-' + optionIdx.toString()"
                     [value]="option"
                     [(ngModel)]="reservation.question_responses[question.name]">
              <label class="form-check-label"
                     [for]="'question-' + question.id.toString() + '-' + optionIdx.toString()">
                {{ option }}
              </label>
            </div>
            <small class="form-text text-muted"
                   *ngIf="question.description"
                   [innerHTML]="getRenderedInlineMarkdown(question.description)"></small>
          </div>

          <div class="mt-2" *ngIf="question.question_type === EventQuestionType.singleCheckbox">
            <div class="form-check">
              <input type="checkbox" class="form-check-input"
                     [id]="'question-' + question.id.toString()"
                     [checked]="singleCheckboxChecked(reservation.question_responses, question.name)"
                     (change)="toggleSingleCheckbox(reservation.question_responses, question.name)">
              <label class="form-check-label"
                     [for]="'question-' + question.id.toString()">
                <span [innerHTML]="getRenderedInlineMarkdown(question.name)"></span>
                <span *ngIf="question.is_required">&nbsp;*</span>
              </label>
            </div>
            <small class="form-text text-muted"
                   *ngIf="question.description"
                   [innerHTML]="getRenderedInlineMarkdown(question.description)"></small>
          </div>

          <div class="mt-2" *ngIf="question.question_type === EventQuestionType.multipleCheckboxes">
            <label class="mb-1">
              <span [innerHTML]="getRenderedInlineMarkdown(question.name)"></span>
              <span *ngIf="question.is_required">&nbsp;*</span>
            </label>
            <div class="form-check" *ngFor="let option of question.options.split(','); let optionIdx = index;">
              <input class="form-check-input" type="checkbox"
                     [id]="'question-' + question.id.toString() + '-' + optionIdx.toString()"
                     [checked]="multiCheckboxChecked(reservation.question_responses, question.name, option)"
                     (change)="toggleMultiCheckbox(reservation.question_responses, question.name, option)">
              <label class="form-check-label"
                     [for]="'question-' + question.id.toString() + '-' + optionIdx.toString()">
                {{ option }}
              </label>
            </div>
            <small class="form-text text-muted"
                   *ngIf="question.description"
                   [innerHTML]="getRenderedInlineMarkdown(question.description)"></small>
          </div>

        </div>
      </div>

      <div class="d-block clearfix mt-3" *ngIf="pricingMatrix && (pricingMatrix.per_participant_fees.length > 0)">
        <span>Fee</span>
        <div class="form-check ml-2" *ngFor="let fee of pricingMatrix.per_participant_fees">
          <input class="form-check-input" type="radio"
                 [name]="'reservation_payment_fee_name ' + fee.name"
                 [id]="'reservation_payment_fee_name ' + fee.name"
                 [value]="fee.name"
                 [(ngModel)]="reservation.payment_fee_name">
          <label class="form-check-label"
                 [for]="'reservation_payment_fee_name ' + fee.name">
            {{ fee.name }} ({{ orgConfigService.getCurrencySymbol() }}{{ fee.fee }})
          </label>
        </div>
      </div>

      <div class="d-block clearfix mt-2" *ngIf="pricingMatrix && (pricingMatrix.per_participant_add_ons.length > 0)">
        <span>Add-Ons</span>
        <div class="form-check ml-2" *ngFor="let addOn of pricingMatrix.per_participant_add_ons">
          <input class="form-check-input" type="checkbox"
                 [name]="'reservation_add_on_name ' + addOn.name"
                 [id]="'reservation_add_on_name ' + addOn.name"
                 [checked]="reservation.add_on_names.includes(addOn.name)"
                 (change)="toggleAddOn(reservation.add_on_names, addOn.name)">
          <label class="form-check-label"
                 [for]="'reservation_add_on_name ' + addOn.name">
            {{ addOn.name }} ({{ orgConfigService.getCurrencySymbol() }}{{ addOn.fee }})
          </label>
        </div>
      </div>

      <div class="form-group form-check mt-3" *ngIf="reservation.customer_id">
        <input type="checkbox" class="form-check-input"
               id="sendConfirmationEmail" name="sendConfirmationEmail"
               [(ngModel)]="reservation.send_confirmation_email">
        <label class="form-check-label" for="sendConfirmationEmail">
          Send reservation confirmation email
        </label>
      </div>

      <div class="form-group form-check mt-3" *ngIf="eventPartId !== null">
        <input type="checkbox" class="form-check-input"
               id="checkInImmediately" name="checkInImmediately"
               [(ngModel)]="checkInImmediately">
        <label class="form-check-label" for="checkInImmediately">
          Check participant into this event immediately
        </label>
      </div>

      <div class="alert alert-warning mt-3 mb-0" role="alert"
           *ngIf="(eventPartId !== null) && checkInImmediately && startsMoreThanOneHourFromNow()">
        This event starts {{ getTimeUntilEventDisplay() }} from now. Are you sure you want to check the participant in now?
      </div>

      <div class="alert alert-warning mt-3 mb-0" role="alert"
           *ngIf="willIncreaseEventSize">
        This private event has no open spots. Adding this participant will
        increase the size of the private event by 1.
      </div>

    </ng-container>

  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()">
      Cancel
    </button>
    <button class="btn btn-primary" type="button"
            *ngIf="!loadingSubmit"
            [disabled]="!reservation.customer_id || loading"
            [class.disabled]="!reservation.customer_id || loading"
            (click)="handleSubmit()">
      Add Participant
    </button>
    <button type="button" class="btn btn-primary disabled" disabled
            *ngIf="loadingSubmit">
      Loading...
    </button>
  </div>

</ng-container>
